/**
 * 滚动到顶部加载更多
 * Bai.Zhiming
 * 2019-7-16
 */
angular.module('scrollTopLoadMoreModule', []).
directive("scrollTopLoadMore", [function() {
    return {
        restrict: "A",
        replace: false,
        scope: false,
        link(scope, $element, $attrs) {
            let element = $element[0],
                timer;
            element.onscroll = function() {
                if (!angular.isFunction(scope.scrollTopLoadMore)) return; //如果回调不存在，拦截
                if (this.scrollTop != 0) return; //如果没滚动到最顶部，拦截
                if (timer) {
                    clearTimeout(timer);
                    timer = null;
                }
                timer = setTimeout(() => {
                    scope.scrollTopLoadMore();
                    this.scrollTop = 10;
                }, 8e2)
            }
            scope.$on("$destroy", () => {
                clearTimeout(timer);
            })
        }
    };
}]);